import { unref as _unref, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '@/assets/conclee6e549.png';
import _imports_1 from '@/assets/conclbafe0a69.png';
const _hoisted_1 = {
  class: "container"
};
const _hoisted_2 = {
  class: "about-header"
};
const _hoisted_3 = ["src"];
import { reactive, onMounted } from 'vue';
import { menus } from '@/api';
export default {
  __name: 'index',
  setup(__props) {
    const hearderbg = require('@/assets/conbanner.png');
    const menusData = reactive([]);
    const getMenus = async () => {
      try {
        const {
          data
        } = await menus({
          type: 5
        });
        console.log('getMenus success: ', data);
      } catch (error) {
        console.log(error);
      }
    };
    onMounted(() => {
      // getMenus()
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("img", {
        src: _unref(hearderbg),
        alt: "header",
        class: "header-img"
      }, null, 8, _hoisted_3), _cache[0] || (_cache[0] = _createElementVNode("div", {
        class: "header-content"
      }, [_createElementVNode("div", {
        class: "header-title-ch"
      }, "联系我们"), _createElementVNode("div", {
        class: "header-title"
      }, "CONTACT US")], -1))]), _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"content-wrap\" data-v-45755906><div style=\"padding:0 16px;\" data-v-45755906><img src=\"" + _imports_0 + "\" alt=\"联系方式\" data-v-45755906></div><div class=\"content\" data-v-45755906><div class=\"title\" data-v-45755906>联系方式</div><div class=\"desc-title-border\" data-v-45755906><div class=\"desc-title\" data-v-45755906>CONTACT</div></div><div class=\"ticketing-content\" data-v-45755906><div class=\"info-title\" data-v-45755906>奥林匹克森林公园位于奥运中心区北部，南起科荟路，北临清河，东至安立路，西至林萃路。</div><div class=\"parking-location\" data-v-45755906><div class=\"content-item\" data-v-45755906>游客服务中心</div><div class=\"content-item\" data-v-45755906>邮政编码</div><div class=\"content-item\" data-v-45755906><span data-v-45755906>电话：64529060</span></div><div class=\"content-item\" data-v-45755906><span data-v-45755906>邮箱：aosen@163.com</span></div></div><div class=\"line-dashed\" data-v-45755906></div></div></div></div><div class=\"content-wrap\" data-v-45755906><div style=\"padding:0 16px;\" data-v-45755906><img src=\"" + _imports_1 + "\" alt=\"单位地址\" data-v-45755906></div><div class=\"content\" data-v-45755906><div class=\"title\" data-v-45755906>单位地址</div><div class=\"desc-title-border\" data-v-45755906><div class=\"desc-title\" data-v-45755906>UNIT ADRESS</div></div><div class=\"ticketing-content\" data-v-45755906><div class=\"info-title\" data-v-45755906>世奥森林公园开发经营有限公司</div><div class=\"content-item\" data-v-45755906><span data-v-45755906>地址：北京市朝阳区北五环仰山桥西1000米</span></div><div class=\"content-item\" style=\"margin-top:16px;\" data-v-45755906>游客服务中心</div><div class=\"content-item\" data-v-45755906><span data-v-45755906>地址：奥林匹克森林公园南主门西侧</span></div></div></div></div>", 2))]);
    };
  }
};